import {
  NOTIFICATIONS_INCLUDE, USER, USER_CASHBACK, USER_CLEAR, USER_EDIT, USER_VERIFY,
  USERS, USERS_BATCH, USERS_PAGINATE, USERS_PARAMS, USERS_QUERY
} from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import UsersQuery from '@graphQL/queries/Users'
import UserCashbackQuery from '@graphQL/queries/UserCashback'
import UserQuery from '@graphQL/queries/User'

const state = {
  list: [],
  details: {},
  paginate: {},
  params: {
    search: ''
  }
}

const getters = {
  [USERS]: 'list',
  [USER]: ({ details }) => {
    const { companies: company, ...rest } = details || {}
    return { ...rest, company }
  },
  [USERS_PAGINATE]: 'paginate',
  [USERS_PARAMS]: 'params'
}

const mutations = {
  [USERS]: 'list',
  [USER]: 'details',
  [USER_CLEAR]: (state) => {
    state.details = {}
  },
  [USERS_PAGINATE]: 'paginate',
  [USERS_QUERY]: (state, payload) => {
    state.params.search = payload
  }
}

const actions = {

  [USERS]: async ({ commit, getters }, payload = {}) => {
    if (payload.hasOwnProperty('search')) commit(USERS_QUERY, payload.search)
    const params = getters[USERS_PARAMS]
    const response = await graphQL(UsersQuery, { ...payload, ...params })
    const { data: users, ...paginate } = response?.data?.data?.users || {}
    commit(USERS, users)
    commit(USERS_PAGINATE, paginate)
  },

  [USER_CLEAR]: async ({ commit }) => {
    commit(USER_CLEAR)
  },

  [USER]: async ({ commit }, payload = {}) => {
    const response = await graphQL(UserQuery, { ...payload })
    const { user } = response?.data?.data || {}
    commit(USER, user)
  },

  [USER_CASHBACK]: async ({ commit, getters }, payload = {}) => {
    if (payload.hasOwnProperty('search')) commit(USERS_QUERY, payload.search)
    const params = getters[USERS_PARAMS]
    const response = await graphQL(UserCashbackQuery, { ...payload, ...params })
    const { data: users, ...paginate } = response?.data?.data?.users || {}
    commit(USERS, users)
    commit(USERS_PAGINATE, paginate)
  },

  [USER_EDIT]: async ({ dispatch }, payload = {}) => {
    const { id } = payload
    const method = id ? 'put' : 'post'
    const urlId = id ? '/' + id : ''

    try {
      const response = await axios[method](`/user${urlId}`, payload)
      const message = `Usuário ${id ? 'alterado' : 'criado'} com sucesso!`

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message
      })
      return response
    } catch (error) {
      const { data: errors } = error.response.data

      if (errors) {
        Object.keys(errors).map(property => {
          const message = (errors[property][0] || '')
          dispatch(NOTIFICATIONS_INCLUDE, {
            type: 'error', message
          })
        })
      } else {
        const message = `Não foi possível ${id ? 'alterar os dados d' : 'criar '}o usuário.`
        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'error', message
        })
      }
      return error
    }
  },

  [USERS_BATCH]: async ({ dispatch }, { users, action }) => {
    const ids = users.map(({ id }) => id)
    await axios.post('/user/action', { action, ids })
    await dispatch(USERS)
  },

  [USER_VERIFY]: (_, payload) => {
    return axios.post('user/verify', payload)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/users.js